import { DatePipe, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MainService } from '../service/main.service';
import { ApiUrls } from '../apiRouts';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ToasterServiceService } from '../service/toaster.service';
import { LocalStorageService } from '../service/local-storage.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  user_id: string | null | undefined;
  cityId: string = '';
  dataCityList: any = [];
  subdivisionList: any = [];
  getRelationList: any;
  getMemberList: any;
  getMemberFilterList: any;
  getRelationFilterList: any;
  villageList: any = [];
  dataCityListFilter: any;
  maternal_dataCityListFilter: any;
  dataDistrictListFilter: any;
  maternalDataDistrictListFilter: any;
  dataSubdivisionListFilter: any;
  maternalDataSubdivisionListFilter: any;
  dataVillageListFilter: any;
  maternalDataVillageListFilter: any;
  dataDistrictList: any = [];
  showInitialOption = true;
  selectedCityId: any = 0;
  maternalSelectedCityId: any = 0;
  selectedDistrictId: any = 0;
  selectedSubdivisionId: any = 0;
  maternalSelectedSubdivisionId: any = 0;
  selectedVisionId: any = 0;
  maternalSelectedVisionId: any = 0;
  selectedRelationId: any = 0;
  selectedMemberId: any = 0;
  routData: any;
  profileForm: any = FormGroup;
  memberId: any = 0;
  main_member_id: any = 0;
  submitted = false;
  baseUrl = environment.imageURL;
  datePipe = new DatePipe("en-US")
  maxDate: Date = new Date();
  action: any;
  pageName: any;
  fileToUpload: any;
  imageUrlApi: any = '';
  imageUrl: any;
  showOption = true;
  hideEducation = true;
  educationOptions: any = [
    { label: 'શિક્ષણ', value: '' },
    { label: 'Standard 1', value: 'Standard 1' },
    { label: 'Standard 2', value: 'Standard 2' },
    { label: 'Standard 3', value: 'Standard 3' },
    { label: 'Standard 4', value: 'Standard 4' },
    { label: 'Standard 5', value: 'Standard 5' },
    { label: 'Standard 6', value: 'Standard 6' },
    { label: 'Standard 7', value: 'Standard 7' },
    { label: 'Standard 8', value: 'Standard 8' },
    { label: 'Standard 9', value: 'Standard 9' },
    { label: 'Standard 10', value: 'Standard 10' },
    { label: 'Standard 11 Commerce', value: 'Standard 11 Commerce' },
    { label: 'Standard 11 Science', value: 'Standard 11 Science' },
    { label: 'Standard 12 Commerce', value: 'Standard 12 Commerce' },
    { label: 'Standard 12 Science', value: 'Standard 12 Science' },
    { label: 'Diploma', value: 'Diploma' },
    { label: 'Bachelors Degree', value: 'Bachelors Degree' },
    { label: 'Masters Degree', value: 'Masters Degree' },
    { label: 'PHD', value: 'PHD' },
    { label: 'Other', value: 'Other' }
  ];

  //gender options
  genderOptions: any = [
    { label: 'જાતિ', value: '' },
    { label: 'સ્ત્રી', value: 'સ્ત્રી' },
    { label: 'પુરૂષ', value: 'પુરૂષ' },
  ];

  //Blod group
  bloodGroupOptions: any = [
    { label: 'બ્લડ ગ્રુપ', value: '' },
    { label: 'O-', value: 'O-' },
    { label: 'O+', value: 'O+' },
    { label: 'A-', value: 'A-' },
    { label: 'A+', value: 'A+' },
    { label: 'B-', value: 'B-' },
    { label: 'B+', value: 'B+' },
    { label: 'AB-', value: 'AB-' },
    { label: 'AB+', value: 'AB+' },
    { label: 'No idea', value: 'No idea' },
  ];
  currentImage = "";

  constructor(private location: Location,
    private mainService: MainService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private _router: Router,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService) {
    this.imageUrl = 'assets/img/user_.jpg';
    this.profileForm = this.fb.group({
      name: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      address: [''],
      relation_id: [''],
      contact_no: [''],
      gender: [''],
      whatsapp_no: [''],
      business: [''],
      office_contact: [''],
      office_address: [''],
      education: [''],
      blood_group: [''],
      member_id: [''],
      image_file: [''],
      current_city_id: [''],
      district_id: [''],
      subdivision_id: [''],
      village_id: [''],
      user_id: [Number(this.localStorageService.getItem('user_id'))],
      is_verified: [''],
      user_type_id: [''],
      password: [''],
      created_by: [''],
      education_description: ['']
    })
    this.route.params.subscribe((params: any) => {
      this.routData = params;
      this.memberId = this.routData.memberId;
      this.action = this.routData.action;
      this.pageName = this.routData.page
    });
    this.getCityListData();
    this.getDistrictListData();
    this.getRelationListData();
    this.getAllMemberData();
    this.getAllVillageDataList();

  }
  
  goBackToPrevPage() {
    this.location.back();
  }
  get f() {
    return this.profileForm.controls;
  }

  ngOnInit() {
    this.user_id = this.action == 'Edit' ? this.memberId : this.localStorageService.getItem('user_id');
    switch (this.action) {
      case 'Edit':
        this.user_id = this.memberId;
        this.getUser();
        break;

      case 'Add':
        if (this.pageName == 'memberPage') {
          this.user_id = '0';
          this.profileForm.controls['relation_id'].setValidators(null);
          this.profileForm.controls['member_id'].setValidators(null);
        } else {
          this.user_id = this.localStorageService.getItem('user_id');
        }
        break;

      case 'addNewMainMember':
        this.user_id = '0';
        this.profileForm.controls['relation_id'].setValidators(null)
        this.profileForm.controls['member_id'].setValidators(null)
        break;

      case 'editMainMember':
        this.user_id = this.memberId;
        this.getUser();
        this.profileForm.controls['relation_id'].setValidators(null)
        this.profileForm.controls['member_id'].setValidators(null)
        break;

      default:
        break;
    }

  }

  errorHandler(event: any) {
    event.target.src = this.imageUrl;
  }

  hideInitialOption() {
    this.showInitialOption = false;
  }

  hideBloodGroupWord() {
    this.showOption = false;
  }

  hideEducationWord() {
    this.hideEducation = false;
  }

  onDateSelected(event: any): void {
    const selectedDate = event.value;
  }

  getUser() {
    this.mainService.getApi(ApiUrls.userList + this.user_id).subscribe((res: any) => {
      if (res.status == 1) {
        this.profileForm.patchValue(res.user[0]);
        if (res.user[0].image.length > 0) {
          this.imageUrlApi = res.user[0].image;
          this.currentImage = res.user[0].image;
        }
        this.profileForm.controls['current_city_id'].setValue(res.user[0])
        this.profileForm.controls['district_id'].setValue(res.user[0])
        this.profileForm.controls['subdivision_id'].setValue(res.user[0])
        this.profileForm.controls['village_id'].setValue(res.user[0])
        //this.profileForm.controls['maternal_village_id'].setValue(res.user[0])
        this.profileForm.controls['relation_id'].setValue(res.user[0])
        this.profileForm.controls['member_id'].setValue(res.user[0])
        this.selectedCityId = res.user[0].current_city_id;
        this.selectedVisionId = res.user[0].village_id;
        this.selectedRelationId = res.user[0].relation_id;
        this.selectedSubdivisionId = res.user[0].subdivision_id;
        this.maternalSelectedVisionId = res.user[0].maternal_village_id;
        this.selectedMemberId = res.user[0].main_member_id;
        this.getAllMemberData();
        this.getSubDivision(this.selectedDistrictId);
        if (this.selectedSubdivisionId !== "") {
          this.getVillages(this.selectedSubdivisionId);
        }
        let educationLength = this.educationOptions.filter((x: any) => x.value == res.user[0].education).length;
        if (educationLength == 0) {
          this.profileForm.controls['education'].setValue('Other');
          this.profileForm.controls['education_description'].setValue(res.user[0].education);
        } else {
          this.profileForm.controls['education'].setValue(res.user[0].education);
        }
      }
    });
  }

  cityFilter(val: any) {
    this.selectedCityId = val.city_id;
  }

  citytFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataCityListFilter = this.dataCityListFilter.filter((option: any) =>
        option.city_name.toLowerCase().includes(filterValue))
    } else {
      this.dataCityListFilter = this.dataCityList;
    }
  }

  displayFnCity(option: any): string {
    if (option) {
      return option && option.city_name ? option.city_name : '';
    } else {
      return '';
    }
  }

  maternalCityFilter(val: any) {
    this.maternalSelectedCityId = val.city_id;
  }

  getCityListData() {
    this.mainService.getApi(ApiUrls.cityList).subscribe((res: any) => {
      this.dataCityList = res.city;
      this.dataCityListFilter = res.city;
      this.maternal_dataCityListFilter = this.dataCityList
    })
  }

  cityFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataCityListFilter = this.dataCityListFilter.filter((option: any) =>
        option.city_name.toLowerCase().includes(filterValue))
    } else {
      this.dataCityListFilter = this.dataCityList;
    }
  }

  maternalCityFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.maternal_dataCityListFilter = this.maternal_dataCityListFilter.filter((option: any) =>
        option.city_name.toLowerCase().includes(filterValue))
    } else {
      this.maternal_dataCityListFilter = this.dataCityList;
    }
  }

  getDistrictListData() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      this.dataDistrictList = res.district.filter((x: any) => x.is_active == 1);
      this.dataDistrictListFilter = this.dataDistrictList;
      this.maternalDataDistrictListFilter = this.dataDistrictList
    })
  }

  districtFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataDistrictListFilter = this.dataDistrictListFilter.filter((option: any) =>
        option.district_name.toLowerCase().includes(filterValue))
    } else {
      this.dataDistrictListFilter = this.dataDistrictList;
    }
  }

  maternalDistrictFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.maternalDataDistrictListFilter = this.maternalDataDistrictListFilter.filter((option: any) =>
        option.district_name.toLowerCase().includes(filterValue))
    } else {
      this.maternalDataDistrictListFilter = this.dataDistrictList;
    }
  }

  displayFnDistrict(option: any): string {
    if (option) {
      return option && option.district_name ? option.district_name : '';
    } else {
      return '';
    }
  }

  districtFilter(val: any) {
    this.selectedDistrictId = val.district_id;
    this.getSubDivision(this.selectedDistrictId);
  }

  submit() {
    this.submitted = true;
    if (this.profileForm.valid) {
      let data = {
        user_id: Number(this.user_id),
        name: this.profileForm.value.name,
        address: this.profileForm.value.address,
        contact_no: this.profileForm.value.contact_no.toString() || '',
        whatsapp_no: this.profileForm.value.whatsapp_no.toString(),
        business: this.profileForm.value.business,
        office_contact: this.profileForm.value.office_contact.toString(),
        office_address: this.profileForm.value.office_address,
        village_id: this.selectedVisionId || 0,
        current_city_id: this.selectedCityId || 0,
        education: this.profileForm.value.education == 'Other' ? this.profileForm.value.education_description : this.profileForm.value.education,
        dob: this.datePipe.transform(this.profileForm.value.dob, "yyyy-MM-dd"),
        blood_group: this.profileForm.value.blood_group,
        gender: this.profileForm.value.gender,
        image: this.currentImage, // Assigning an empty string for image
        image_file: null,
        relation_id: this.selectedRelationId || 0,
        main_member_id: Number(this.selectedMemberId) || 0,
        //maternal_name: this.profileForm.value.maternal_name,
        maternal_village_id: this.maternalSelectedVisionId || 0,
        is_verified: this.profileForm.value.is_verified || 0,
        user_type_id: this.profileForm.value.user_type_id || 0,
        password: this.profileForm.value.contact_no.toString() || null,
        created_by: this.profileForm.value.created_by || 0,
        //death_date: this.profileForm.value.death_date || '',
        Action: (this.action == 'Edit' || this.action == 'editMainMember') ? 'UPDATE' : 'SIGNUP',
      };
      this.mainService.postApi(ApiUrls.userSignUp, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          if (this.profileForm.get('image_file') != '' && this.profileForm.get('image_file') !== undefined && this.profileForm.get('image_file') !== null) {
            let formData = new FormData();
            formData.append('user_id', res.user[0].user_id);
            formData.append('image_file', this.profileForm.value.image_file);
            this.mainService.postFormDataApi(ApiUrls.userPhoto, formData, 1).subscribe((res: any) => {
              if (res.status == 1) {
                if (JSON.parse(this.localStorageService.getItem('loginData')).user_id == res.user[0].user_id) {
                  this.localStorageService.setData('loginData', JSON.stringify(res.user[0]));
                  this.mainService.triggerProfileData();
                  this._router.navigate(["/dashboard"]);
                }
              }
            });
          }
          if (!localStorage.getItem('loginData')) {
            if (JSON.parse(this.localStorageService.getItem('loginData')).user_id == res.user[0].user_id)
              this.localStorageService.setData('loginData', JSON.stringify(res.user[0]));
          }
          this.toasterService.toastSuccess(res.response)
          this.profileForm.reset();
          this.submitted = false;
          if (this.pageName == 'memberPage') {
            this.location.back();
          } else {
            this.getUser();
          }
        }
        else {
          this.mainService.triggerProfileData();
          this.toasterService.toastError(res.response)
          this.submitted = true;
        }
      });
    }
  }

  getSubDivision(id: any) {
    this.mainService.getApi(ApiUrls.subdivisionListSelect + id).subscribe((res: any) => {
      this.subdivisionList = res.subdivision.filter((x: any) => x.is_active == 1);
      this.dataSubdivisionListFilter = res.subdivision.filter((x: any) => x.is_active == 1);;
      this.maternalDataSubdivisionListFilter = this.subdivisionList;
    });
  }

  SubdivisionFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataSubdivisionListFilter = this.dataSubdivisionListFilter.filter((option: any) =>
        option.subdivision_name.toLowerCase().includes(filterValue))
    } else {
      this.dataSubdivisionListFilter = this.subdivisionList;
    }
  }

  maternalSubdivisionFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataSubdivisionListFilter = this.dataSubdivisionListFilter.filter((option: any) =>
        option.subdivision_name.toLowerCase().includes(filterValue))
    } else {
      this.dataSubdivisionListFilter = this.subdivisionList;
    }
  }

  displayFnSubdivision(option: any): string {
    if (option) {
      return option && option.subdivision_name ? option.subdivision_name : '';
    } else {
      return '';
    }
  }

  maternalDisplayFnSubdivision(option: any): string {
    if (option) {
      return option && option.subdivision_name ? option.subdivision_name : '';
    } else {
      return '';
    }
  }

  subdivisionFilter(val: any) {
    this.selectedSubdivisionId = val.subdivision_id;
    this.getVillages(this.selectedSubdivisionId);
  }

  maternalSubdivisionFilter(val: any) {
    this.maternalSelectedSubdivisionId = val.subdivision_id;
    this.getVillages(this.maternalSelectedSubdivisionId);
  }

  getVillages(id: any) {
    this.mainService.getApi(ApiUrls.villageListSelect + id).subscribe((res: any) => {
      this.villageList = res.village.filter((x: any) => x.is_active == 1);
      this.dataVillageListFilter = res.village.filter((x: any) => x.is_active == 1);
    });
  }

  VillageFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.dataVillageListFilter = this.dataVillageListFilter.filter((option: any) =>
        option.village_name.toLowerCase().includes(filterValue))
    } else {
      this.dataVillageListFilter = this.villageList;
    }
  }

  maternalVillageFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.maternalDataVillageListFilter = this.maternalDataVillageListFilter.filter((option: any) =>
        option.maternal_village_name.toLowerCase().includes(filterValue))
    } else {
      this.maternalDataVillageListFilter = this.villageListAll;
    }
  }

  displayFnVillage(option: any): string {
    if (option) {
      return option && option.village_name ? option.village_name : '';
    } else {
      return '';
    }
  }

  maternalDisplayFnVillage(option: any): string {
    if (option) {
      return option && option.maternal_village_name ? option.maternal_village_name : '';
    } else {
      return '';
    }
  }

  VillageFilter(val: any) {
    this.selectedVisionId = val.village_id;
  }

  maternalVillageFilter(val: any) {
    this.maternalSelectedVisionId = val.village_id;
  }

  getImage(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileToUpload = event.target.files[0];
      this.profileForm.controls['image_file'].setValue(file);

      // For Image Preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        this.imageUrlApi = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
    }
  }

  displayFnsRelation(option: any): string {
    if (option) {
      return option && option.relation_name ? option.relation_name : '';
    } else {
      return '';
    }
  }

  getRelationListData() {
    this.mainService.getApi(ApiUrls.relationList).subscribe((res: any) => {
      if (res.status == 1) {
        this.getRelationList = res.relation
        this.getRelationFilterList = this.getRelationList
      }
    })
  }

  relationFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.getRelationFilterList = this.getRelationFilterList.filter((option: any) =>
        option.relation_name.toLowerCase().includes(filterValue))
    } else {
      this.getRelationFilterList = this.getRelationList;
    }
  }

  relationFilter(val: any) {
    this.selectedRelationId = val.relation_id;
  }

  getAllMemberData() {
    this.mainService.getApi(ApiUrls.allMainMemberList).subscribe((res: any) => {
      if (res.status == 1) {
        this.getMemberList = res.user
        this.getMemberFilterList = this.getMemberList
        if (this.action == 'Add' && this.pageName == 'memberPage') {
          this.selectedMemberId = this.memberId;
          this.getMemberFilterList = this.getMemberList.filter((x: any) => x.user_id == this.memberId)
          this.profileForm.controls['member_id'].setValue(this.getMemberFilterList[0])
        } else if (this.action == 'Edit') {
          this.getMemberFilterList = this.getMemberList.filter((x: any) => x.user_id == this.selectedMemberId)
          this.profileForm.controls['member_id'].setValue(this.getMemberFilterList[0])
        }
      }
    })
  }

  displayFnsMember(option: any): string {
    if (option) {
      return option && option.name ? option.name : '';
    } else {
      return '';
    }
  }

  memberFilter(val: any) {
    this.selectedMemberId = val.user_id;
  }

  memberFilterList(event: any) {
    const filterValue = event.target.value.toLowerCase();
    if (filterValue != '') {
      this.getMemberFilterList = this.getMemberFilterList.filter((option: any) =>
        option.relation_name.toLowerCase().includes(filterValue))
    } else {
      this.getMemberFilterList = this.getMemberList;
    }
  }

  villageListAll: any;
  getAllVillageDataList() {
    this.mainService.getApi(ApiUrls.getAllVillageList).subscribe((res: any) => {
      this.villageListAll = res.village;
      this.maternalDataVillageListFilter = this.villageListAll;
    });
  }

}